import { RestAPI } from "./rest-api.service";
import { BASE_URL } from "../types/constants";
import {
    EventDetail,
    FightCardEventsResponse,
    FightCardItem,
    FightCardSearchParams,
    HomeFightCardsResponse
} from "../types/fight-cards.types";

const api = new RestAPI();

const buildSearchParams = (params?: FightCardSearchParams) => {
    const searchParams = new URLSearchParams();

    if (!params) {
        return searchParams;
    }

    if (params.search) {
        searchParams.set('search', params.search);
    }

    if (typeof params.decade === 'number') {
        searchParams.set('decade', params.decade.toString());
    }

    if (typeof params.year === 'number') {
        searchParams.set('year', params.year.toString());
    }

    if (typeof params.page === 'number') {
        searchParams.set('page', params.page.toString());
    }

    if (typeof params.pageSize === 'number') {
        searchParams.set('pageSize', params.pageSize.toString());
    }

    if (params.sort) {
        searchParams.set('sort', params.sort);
    }

    return searchParams;
};

export const fetchFightCardEvents = async (
    params?: FightCardSearchParams,
    token?: string | null,
    signal?: AbortSignal
): Promise<FightCardEventsResponse> => {
    const searchParams = buildSearchParams(params);
    const query = searchParams.toString();
    const url = BASE_URL + `/v1/fight-cards/events${query ? `?${query}` : ''}`;
    return signal ? await api.get(url, token, signal) : await api.get(url, token);
};

export const fetchFightCardEventDetail = async (
    eventId: string,
    includeThumbnails: boolean = false,
    token?: string | null
): Promise<EventDetail> => {
    const query = includeThumbnails ? '?includeThumbnails=true' : '';
    const url = BASE_URL + `/v1/fight-cards/events/${eventId}${query}`;
    return await api.get(url, token);
};

export const fetchFightCardFights = async (
    eventId: string,
    includeThumbnails: boolean = false,
    token?: string | null
): Promise<FightCardItem[]> => {
    const query = includeThumbnails ? '?includeThumbnails=true' : '';
    const url = BASE_URL + `/v1/fight-cards/events/${eventId}/fights${query}`;
    return await api.get(url, token);
};

export const fetchFightCardInterviews = async (
    eventId: string,
    includeThumbnails: boolean = false,
    token?: string | null
): Promise<FightCardItem[]> => {
    const query = includeThumbnails ? '?includeThumbnails=true' : '';
    const url = BASE_URL + `/v1/fight-cards/events/${eventId}/interviews${query}`;
    return await api.get(url, token);
};

export const fetchHomeFightCards = async (
    limit: number = 3,
    token?: string | null
): Promise<HomeFightCardsResponse> => {
    const url = BASE_URL + `/v1/fight-cards/home?limit=${limit}`;
    return await api.get(url, token);
};
